import Image from '@/components/UI/Image';
import EfModal from '@/components/UI/Modal';
import { useGlobal } from '@/utils/useGlobal';
import type { ModalFuncProps } from 'antd';
import css from './index.module.scss';
interface props extends ModalFuncProps {
    howToConnectImg: string;
    solarNumber: number;
}
export default function HowToConnectImg({ visible, howToConnectImg, title, solarNumber, onCancel }: props) {
    const { isMobile, useEffect, useLang } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');

    useEffect(() => {
        if (isMobile && visible) {
            document.documentElement.style.overflowY = 'hidden';
        }
        return () => (document.documentElement.style.overflowY = '');
    }, []);
    return (
        <>
            <EfModal visible={visible} onCancel={onCancel} width={isMobile ? '3.45rem' : 644} className={css.how_to_connect}>
                <h5 className="how-to-connect-title">{title}</h5>
                <div className={`sample_img connect_${solarNumber}`}>
                    <Image src={howToConnectImg} layout="fill" alt={title} />
                    <span className="input-text">{t('calc_step3_input_text')}</span>
                    <span className="xt60-text">{t('calc_step3_xt60_text')}</span>
                </div>
            </EfModal>
        </>
    );
}
